import React, {type ReactNode} from 'react'
import {T, Tooltip} from '@colonist/ui'
import {useUIGameTranslationContext} from '../../../../../contexts/UIGameTranslationContext.tsx'

interface TooltipResourceCardsProps {
    resourceCardCount: number
    resourceCardDiscardLimit: number
    children: ReactNode
}

export const TooltipResourceCards = ({
    resourceCardCount,
    resourceCardDiscardLimit,
    children,
}: TooltipResourceCardsProps) => {
    const {translationKeyContext} = useUIGameTranslationContext()
    const isResourceCardCountOverLimit = resourceCardCount > resourceCardDiscardLimit
    return (
        <Tooltip
            title={<T id={{
                key: 'strings:game.playerInformation.resourceCard.title',
                options: {context: translationKeyContext},
            }}/>}
            content={
                <>
                    <div><T id={{
                        key: 'strings:game.playerInformation.resourceCard.body',
                        options: {context: translationKeyContext},
                    }}/></div>
                    {isResourceCardCountOverLimit && <div><br/><T id={{
                        key: 'strings:game.playerInformation.resourceCard.discardLimitTip',
                        options: {count: resourceCardDiscardLimit},
                    }}/></div>}
                </>}>
            {children}
        </Tooltip>
    )
}
